import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useBankAccount() {
  const getBankAccounts = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/bankAccounts/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };
  const queryBankAccounts = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;
    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/bankAccounts/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };
  const createBankAccounts = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/bankAccounts`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchBankAccounts = async (id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/bankAccounts/${id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const deleteBankAccounts = async (bankAccountsId) => {
    const result = await axios.delete(`${apiUri}/api/v1/bankAccounts/${bankAccountsId}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };



  return {
    queryBankAccounts: queryBankAccounts,
    getBankAccounts: getBankAccounts,
    createBankAccounts: createBankAccounts,
    patchBankAccounts: patchBankAccounts,
    deleteBankAccounts: deleteBankAccounts,
  };
}
